(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-finalized.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-finalized.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo;
const clx = svs.components.lbUtils.clx;
const _svs$components$marke = svs.components.marketplaceCompetition.overviewHero.common,
  CompetitionLogo = _svs$components$marke.CompetitionLogo,
  LoginButton = _svs$components$marke.LoginButton,
  TrixaButton = _svs$components$marke.TrixaButton,
  VisitGameButton = _svs$components$marke.VisitGameButton;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const ordinalNumber = svs.components.marketplaceCompetition.overviewHero.helpers.ordinalNumber;
const _svs$components$marke2 = svs.components.marketplaceCompetition.overviewHero.hooks,
  useMobileQuery = _svs$components$marke2.useMobileQuery,
  useTrixa = _svs$components$marke2.useTrixa;
const _svs$components$marke3 = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState,
  IS_NOT_REGISTERED = _svs$components$marke3.IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET = _svs$components$marke3.HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET = _svs$components$marke3.HAS_CURRENT_BET;
const UserNotLoggedIn = _ref => {
  let competition = _ref.competition;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Logga in f\xF6r att se dina resultat")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let competition = _ref2.competition,
    compName = _ref2.compName,
    isMobile = _ref2.isMobile,
    showTrixa = _ref2.showTrixa;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "T\xE4vlingen har startat!")), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Du deltar inte i \xE5rets ".concat(compName, ",")), !isMobile && React.createElement("span", null, "men du kan ist\xE4llet t\xE4vla i antal kickar")), React.createElement(TrixaButton, {
    isVisible: !isMobile,
    onClick: showTrixa
  })));
};
const UserHasNoBet = _ref3 => {
  let competition = _ref3.competition,
    compName = _ref3.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "N\xE4sta omg\xE5ng \xF6ppnar snart f\xF6r spel."), React.createElement("span", null, "Gl\xF6m inte att l\xE4mna in ditt spel i tid."))));
};
const UserHasBet = _ref4 => {
  let competition = _ref4.competition;
  const _ref5 = (competition === null || competition === void 0 ? void 0 : competition.details) || {},
    firstDrawNumber = _ref5.firstDrawNumber,
    currentDrawNumber = _ref5.currentDrawNumber;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber;
      return React.createElement(React.Fragment, null, React.createElement("span", null, "R\xE4tta ditt spel f\xF6r"), React.createElement("span", null, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "R\xE4tta ditt spel!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, currentGameTitle)), React.createElement(VisitGameButton, {
    competition: competition
  }));
};
const CompetitionClosedDrawFinalized = _ref6 => {
  let branding = _ref6.branding,
    competition = _ref6.competition,
    userState = _ref6.userState;
  const compName = resolveCompetitionName(competition);
  const isMobile = useMobileQuery();
  const _useTrixa = useTrixa(),
    _useTrixa2 = _slicedToArray(_useTrixa, 2),
    showTrixa = _useTrixa2[0],
    Trixa = _useTrixa2[1];
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName,
          isMobile: isMobile,
          showTrixa: showTrixa
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition
        });
    }
  };
  if (Trixa) {
    return React.createElement(Trixa, {
      active: true,
      branding: branding,
      classNames: "competition-overview-hero competition-closed-draw-finalized"
    });
  }
  return React.createElement("div", {
    className: clx('competition-overview-hero competition-closed-draw-finalized', userState)
  }, renderContentBasedOnUserState(userState));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionClosedDrawFinalized', CompetitionClosedDrawFinalized);

 })(window);